/**
 * This fn will return object with name of component like we use it in our codebase and potential props based on componentName
 * In FormField.vue, you have to import these components
 */
export default componentName => {
	const dictionary = {
		// Basic ones
		text: {
			name: "j-base-input-text",
			props: {}
		},
		longText: {
			name: "j-base-input-long-text",
			props: {}
		},
		number: {
			name: "j-base-input-number",
			props: {}
		},
		date: {
			name: "j-base-date-picker-simple",
			props: {}
		},
		toggle: {
			name: "j-base-toggle",
			props: {}
		},
		select: {
			name: "j-base-select",
			props: {}
		},
		radios: {
			name: "j-base-radios",
			props: {}
		},

		selectProduct: {
			name: "select-product",
			props: {}
		},
		offerPremiumInfo: {
			name: "offer-premium-info",
			props: {
				hasLoadingsActions: false,
				hasDiscountActions: true,
				hasPremiumActions: true,
				hasDiscountLogic: true
			}
		},
		OfferPremiumInfoPropertyAllRisks: {
			name: "offer-premium-info-property-all-risks",
			props: {
				hasLoadingsActions: false,
				hasDiscountActions: true,
				hasPremiumActions: true,
				hasDiscountLogic: true
			}
		},
		proposalPremiumInfo: {
			name: "proposal-premium-info",
			props: {
				hasLoadingsActions: false,
				hasDiscountActions: true,
				hasPremiumActions: true,
				hasDiscountLogic: true
			}
		},
		clauses: {
			name: "clauses-for-offer",
			props: {}
		},
		associatedContractList: {
			name: "associated-contract-list",
			props: {}
		},
		proposalStakeholders: {
			name: "proposal-stakeholders",
			props: {}
		},
		offerStakeholders: {
			name: "offer-stakeholders",
			props: {}
		},
		commissionSplit: {
			name: "commission-split",
			props: {}
		}
	}

	// If componentName is not in the dictionary, return empty object otherwise return component object
	return dictionary[componentName] ? dictionary[componentName] : {}
}
